import { render, staticRenderFns } from "./ProgramSelect.vue?vue&type=template&id=526d161a&scoped=true&lang=pug"
import script from "./ProgramSelect.vue?vue&type=script&lang=js"
export * from "./ProgramSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526d161a",
  null
  
)

export default component.exports